import store from '@/store'

import organizationRoutes from './organization'
import projectsRoutes from './projects'
import userRoutes from './user'
import adminRoutes from './admin'

import MainLayout from '@/components/layout/MainLayout'
import Login from '@/components/views/Login'
import Signup from '@/components/views/Signup'
import NotFoundView from '@/components/404'

import HomeView from '@/components/views/Home'
import Calendar from '@/components/calendar/Calendar'
import PorfolioView from '@/components/portfolio/Portfolio'
import ResourcesView from '@/components/views/Resources'

const baseRoutes = [
  {
    path: 'resources',
    component: ResourcesView,
    name: 'resources',
    meta: { title: 'Resources', permission: 'resources' }
  },
  {
    path: 'analysis',
    component: PorfolioView,
    name: 'portfolio',
    meta: { title: 'Analysis', permission: 'portfolio' }
  },
  {
    path: 'dashboard',
    alias: '',
    component: HomeView,
    name: 'home',
    meta: { title: 'Home' }
  },
  {
    path: 'calendar',
    component: Calendar,
    name: 'calendar',
    meta: { title: 'Calendar' }
  }
]

let allRoutes = []
allRoutes.push(...baseRoutes)
allRoutes.push(...projectsRoutes)
allRoutes.push(...organizationRoutes)
allRoutes.push(...userRoutes)
allRoutes.push(...adminRoutes)
allRoutes.push(...store.state.navigation.extensionsRoutes)

export default [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/signup',
    name: 'signup',
    component: Signup,
    meta: { allowAnonymous: true }
  },
  {
    path: '/',
    component: MainLayout,
    children: allRoutes
  },
  {
    // not found handler
    path: '/404',
    alias: '*',
    component: NotFoundView
  }
]
